import * as Types from './types';

export const parseSuggestions = (suggestions?: string | Types.TInputSuggestions): { label: string; value: string }[] | void => {
    if (!suggestions) {
        return;
    }

    let result = suggestions as Types.TInputSuggestions;

    if (typeof suggestions === 'string' && suggestions.length) {
        try {
            result = JSON.parse(suggestions.replaceAll('\'', '"'));
        // eslint-disable-next-line no-empty
        } catch {}
    }

    try {
        return result.map(item => {
            if (typeof item === 'string' || typeof item === 'number') {
                return { label: String(item), value: String(item) };
            }

            return item;
        });
    // eslint-disable-next-line no-empty
    } catch {}
};
